import React, { useState } from "react";
import { useMerchant } from "../context/merchant";
import { getStatusColor } from "../helpers/utils";
import {
  DRIVER_STAGE_LABEL,
  canExtendPrep,
  formatTime,
  getRemainingTime,
} from "../utils/order-utils";

// ─────────────────────────────────────────────────────────────────────────────
// Захиалгын явц — мөр ба дэлгэрэнгүй цонх ХОЁУЛАА ашиглана (2026-09-17).
//   • PrepExtendButtons — бэлтгэх хугацааг +10 / +20 минут (захиалга тутамд 1 удаа)
//   • DriverStageBadge  — «Жолооч ирж байна» / «Жолооч ирсэн»
// ─────────────────────────────────────────────────────────────────────────────

export const PREP_EXTEND_OPTIONS = [10, 20];

/**
 * Хоол бэлэн болоогүй — хугацааг сунгах. Хэрэглэгч ба жолоочид «ресторан N
 * минутаар сунгалаа» гэж харагдана, тоолуур дахин явна. Нэг удаа л боломжтой.
 *
 * ⚠️ Мөрөн дээрх товч — мөрийн `onClick` (дэлгэрэнгүй нээх) руу товшилт
 * дамжихгүй байхаар `stopPropagation`.
 */
export function PrepExtendButtons({ orderId, large = false, className = "", onDone }) {
  const { extendPrep } = useMerchant();
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  const run = async (e, minutes) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(minutes);
    setError(null);
    const err = await extendPrep(orderId, minutes);
    setBusy(null);
    if (err) setError(err);
    else onDone?.(minutes);
  };

  return (
    <div className={className} onClick={(e) => e.stopPropagation()}>
      <div className="d-flex gap-2 justify-content-center">
        {PREP_EXTEND_OPTIONS.map((m) => (
          <button
            key={m}
            type="button"
            className={`btn btn-warning ${large ? "btn-lg w-100" : "btn-sm"}`}
            disabled={busy != null}
            onClick={(e) => run(e, m)}
          >
            {busy === m ? "..." : `+${m} мин`}
          </button>
        ))}
      </div>
      {error ? <div className="text-danger small mt-1">{error}</div> : null}
    </div>
  );
}

/** Жолооч ЭНЭ ресторан руу явж байна / ирсэн. Бусад үед юу ч харуулахгүй. */
export function DriverStageBadge({ stage, className = "" }) {
  const label = DRIVER_STAGE_LABEL[stage];
  if (!label) return null;
  return <span className={`${label.className} ${className}`}>{label.text}</span>;
}

/**
 * Жагсаалтын «Минут» нүд — шуурхай ба урьдчилсан захиалгын мөр ХОЁУЛАА.
 * Хугацаа дуусмагц улаан 0:00-ийн доор «+10 / +20 мин» (1 удаа).
 */
export function PrepTimeCell({ item }) {
  const remaining = getRemainingTime(item);
  const extendedMin = Math.round(Number(item?.prepExtendedSec || 0) / 60);
  return (
    <td className="text-center">
      {remaining === 0 && item?.status?.id !== 4 ? (
        <span className="badge bg-danger px-1 py-1 fs-6">{formatTime(remaining)}</span>
      ) : (
        formatTime(remaining)
      )}
      {extendedMin > 0 ? (
        <div className="small text-muted mt-1">+{extendedMin} мин сунгасан</div>
      ) : null}
      {canExtendPrep(item, remaining) ? (
        <PrepExtendButtons orderId={item.id} className="mt-2" />
      ) : null}
    </td>
  );
}

/** Жагсаалтын «Төлөв» нүд + жолоочийн шошго. */
export function OrderStatusCell({ item }) {
  return (
    <td className="text-center">
      <span className={getStatusColor(item?.status?.id)}>
        {item?.status?.id === 2 ? "Шинэ" : item?.status?.name || "Тодорхойгүй"}
      </span>
      {item?.driverStage ? (
        <div className="mt-1">
          <DriverStageBadge stage={item.driverStage} />
        </div>
      ) : null}
    </td>
  );
}
